import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Title } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { CompanyEditComponent } from '../company-edit/company-edit.component';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { Company } from './company.model';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})

export class CompanyComponent implements OnInit, OnDestroy {
  private companies: Company[] = [];
  private dataTable: any;
  private dtTable: any;
  private navbarHeadline: any;
  private subs = new SubSink();

  @ViewChild('editModal', { static: false }) editModal: CompanyEditComponent;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private titleService: Title,
    private antiForgery: AntiForgeryTokenService, private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.dataTable = $('#companyTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.createDataTable();
    this.loadData();
  }

  private loadData() {
    this.navbarHeadline.html('Companies');

    this.subs.sink = this.repository.get<Company[]>('api/Company/List').pipe(map(x => x)).subscribe(resp => {
      this.companies = resp.data;
      this.createDataTable();
    });
  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.companies,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'code'
        },
        {
          name: 'name',
        },
        {
          name: 'insAt',
          width: '200px'
        }
      ],
      orderBy: [[1, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['id'],
          action: function (id) {
            that.delete(id);
          }
        }
        ]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      }]
    };

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private create() {
    this.editModal.show(new Company, true);
  }

  private edit(id) {
    let company = this.companies.find(x => x.id === id);

    if (company) {
      this.subs.sink = this.repository.get<Company>('api/Company/Details/' + company.id).pipe(map(x => x.data)).subscribe(resp => {
        this.editModal.show(resp, false);
      });
    }
  }

  private delete(id) {
    let company = this.companies.find(x => x.id === id);

    if (company) {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete company', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to delete " + company.name + "?", MessageType.YESNO, 'Delete confirmation!', () => {
            this.subs.sink = this.repository.del('api/Company/Remove/' + company.id, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete company', 'error');
              } else {
                Toast.Show('Company successfully removed.', 'Delete company', 'success');
                this.loadData();
              }
            });
          });
        }
      });
    }
  }

  private deleteList() {
    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);

    if (checked.length == 0) {
      this.msgDialog.show("You must select company", MessageType.OK, "Delete conformation!");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete company', 'error');
        } else {
          this.msgDialog.show("Are you sure you want do delete " + checked.length + " item(s)?", MessageType.YESNO, "Delete conformation", () => {
            this.subs.sink = this.repository.post<number[]>('api/Company/ListRemove', checked, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete company', 'error');
              } else {
                Toast.Show('Companies successfully removed.', 'Delete companies', 'success');
                this.loadData();
              }
            });
          });
        }
      });
    }
  }

  private onSaved(data: Company) {
    let company = this.companies.find(x => x.id === data.id);

    if (company) {
      company.code = data.code;
      company.name = data.name;
    } else {
      let newCompany = new Company();
      newCompany.id = data.id;
      newCompany.code = data.code;
      newCompany.name = data.name;
      newCompany.insAt = data.insAt;

      this.companies.push(newCompany);
    }

    this.createDataTable();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
